import cloneDeep from 'lodash.clonedeep';
import types from './actionTypes';

const initialState = []


export default function appReducer(state = initialState, action) {
  // console.log("----action----", action)
  switch (action.type) {
    case types.ADD_CLUSTERLET_CONNECTION: {
      return [
        ...state,
        action.payload
      ]
    }

    case types.DELETE_CLUSTERLET_CONNECTION: {
      return state.filter(cc => cc.id !== action.payload.id)
    }

    case types.UPDATE_FULL_CLUSTERLET_CONNECTIONS: {
      return [
        ...state,
        ...action.payload
      ]
    }

    case types.RESET_CLUSTERLET_CONNECTIONS: {
      return [
        ...action.payload
      ]
    }

    case types.EDIT_CLUSTERLET_CONNECTION: {
      
      return [...state.map(cc => cc.id == action.payload.id ? (action.payload) : ({ ...cc }))]

    }

    case 'RESET_BLUEPRINT':
      return cloneDeep(initialState);


    default:
      return state;
  }
}